export default {
  title: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.title',
    defaultMessage: 'Add contact',
  },
  productOriginQuestion: {
    id: 'bo_seller.profile.legal_details.dsa_block.product_origin.question',
    defaultMessage: 'Which is true of your products listed on Back Market?',
  },
  productOriginEU: {
    id: 'bo_seller.profile.legal_details.dsa_block.product_origin.eu_option',
    defaultMessage:
      'All my products are manufactured within the EU or Northern Ireland.',
  },
  productOriginNonEU: {
    id: 'bo_seller.profile.legal_details.dsa_block.product_origin.non_eu_option',
    defaultMessage:
      'Some or all of my products are manufactured outside of the EU or Northern Ireland.',
  },
  continue: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.continue',
    defaultMessage: 'Continue',
  },
  businessName: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.business_name',
    defaultMessage: 'Business name',
  },
  businessAddress: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.business_address',
    defaultMessage: 'Business address',
  },
  addressLine1: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.address_line_1',
    defaultMessage: 'Address line 1',
  },
  addressLine2: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.address_line_2',
    defaultMessage: 'Address line 2 (optional)',
  },
  postalCode: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.postal_code',
    defaultMessage: 'Postal code',
  },
  city: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.city',
    defaultMessage: 'City',
  },
  country: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.country',
    defaultMessage: 'Country',
  },
  contactDetails: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.contact_details',
    defaultMessage: 'Contact details',
  },
  phoneNumber: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.phone_number',
    defaultMessage: 'Phone number',
  },
  phoneNumberDescription: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.phone_number_description',
    defaultMessage: "This phone number won't be visible to customers unless",
  },
  contactInfoDescription: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.contact_info_description',
    defaultMessage:
      'Provide either your email address or website URL (or both!). Only your website will be displayed unless you request otherwise.',
  },
  contactMethod: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.contact_method',
    defaultMessage: 'Contact method 1',
  },
  selectContactMethod: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.select_contact_method',
    defaultMessage: 'Select contact method',
  },
  complianceDisclaimer: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.compliance_disclaimer',
    defaultMessage:
      "By submitting this form, you're confirming that your products comply with regulations (EU) 2023/988 and 2022/2065. You accept full responsibility for compliance and any consequences of non-compliance.",
  },
  addContactButton: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.add_contact_button',
    defaultMessage: 'Add contact',
  },
  email: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.email',
    defaultMessage: 'Email',
  },
  emailDescription: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.email_description',
    defaultMessage:
      "The email address won't be visible to cumster unless requested",
  },
  website: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.website',
    defaultMessage: 'Website',
  },
  fieldIsRequired: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.field_is_required',
    defaultMessage: 'This field is required',
  },
  backButtonLabel: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.back_button_label',
    defaultMessage: 'Back',
  },
  required: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.required',
    defaultMessage: 'This field is required',
  },
  emailInvalid: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.email_invalid',
    defaultMessage: 'Invalid email',
  },
  websiteInvalid: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.website_invalid',
    defaultMessage: 'Invalid website',
  },
  success: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.success',
    defaultMessage: 'Contact added successfully',
  },
  emailOrWebsiteNote: {
    id: 'bo_seller.profile.legal_details.dsa_block.add_contact_form_modal.email_or_website_note',
    defaultMessage:
      'Note: You should either choose to enter an email OR a website',
  },
}
